import { Navigate, Outlet } from 'react-router-dom';
import { useProductsContext } from '../../context/ProductsContext';

export default function InvestorRoute() {
  const { permissions } = useProductsContext();

  if (!permissions.canAccessInvestors) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
